(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/helpers/swish-outage-helpers.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/helpers/swish-outage-helpers.js');

'use strict';

const bankBic = {
  SWEDSES: 'Swedbank',
  HANDSE: 'Handelsbanken',
  ESSESE: 'SEB',
  SKIASE: 'Skandiabanken',
  NDEASE: 'Nordea',
  DABASE: 'Danske Bank',
  ELLFSE: 'Länsförsäkringar'
};
const makeMessage = function (title) {
  let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Välj någon av våra andra insättningsmetoder om Swish inte fungerar.';
  let isButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let buttonText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Visa andra insättningsmetoder';
  let handleClick = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : () => {};
  return {
    title,
    message,
    isButton,
    handleClick,
    buttonText
  };
};
const makeOutageMessage = (paymentMethod, isButton, buttonText, handleClick) => makeMessage("".concat(paymentMethod, " rapporterar om driftst\xF6rningar"), 'Välj någon av våra andra insättningsmetoder om Swish inte fungerar.', isButton, buttonText, handleClick);
svs.accountservicesReact.deposit.helpers.swishOutageHelpers = {
  bankBic,
  makeMessage,
  makeOutageMessage
};

 })(window);